import { isNil } from 'lodash';
import { StylesConfig } from 'react-select';

import { Item } from '@commons/Dropdown/Select/types';
import { Option } from '@commons/Select/types';

import stripHtml from '@utils/stripHtml';

//----------------------------------------------------------------------
// STYLES
//----------------------------------------------------------------------

const flex = '1 1 auto';

export const customStyles: StylesConfig = {
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    flex,
    cursor: isFocused ? 'pointer' : 'default',
    backgroundColor: isSelected || isFocused ? 'transparent' : base.backgroundColor,
    color: isFocused || isSelected ? '#000' : base.color,
    border: isFocused ? '3px solid #1B6EC2' : isSelected ? 'none' : base.border,
    '&:hover': {
      border: '3px solid #1B6EC2',
      outline: 'none'
    },
    // .dropdown_dropdownSelector:focus
    '&:focus': {
      border: '3px solid #1B6EC2',
      outline: 'none'
    }
  }),
  control: (base, { isFocused }) => ({
    ...base,
    flex,
    borderRadius: 0,
    minHeight: 55,
    outline: isFocused ? 'solid 1px #3b4158' : 'none',
  }),
  singleValue: (base) => ({ ...base }),
  container: (base) => ({
    ...base,
    flex,
    width: '50%',
    minWidth: 250,
    // Our mobile res cut (src/css/variables.scss)
    '@media only screen and (max-width: 480px)': {
      width: '100%'
    },
    // .dropdownContainer
    boxShadow: '0px 1px 3px 0px rgba(216, 216, 216, 0.6)',
    // .dropdown_dropdownSelector:hover
    '&:hover': {
      boxShadow: '0px 0px 0px 3px #1B6EC2',
      outline: 'none'
    },
    // .dropdown_dropdownSelector:focus
    '&:focus': {
      boxShadow: '0px 0px 0px 3px #1B6EC2',
      outline: 'none'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  input: (base) => ({
    ...base,
    width: '100%'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1000
  }),
  clearIndicator: (base) => {
    return {
      ...base,
      color: '#8e95a4',
      padding: '4px',
      marginRight: '4px',
    }
  },
  dropdownIndicator: (base) => {
    return {
      ...base,
      color: '#8e95a4',
      padding: '4px',
    }
  },
  placeholder: (base) => {
    return {
      ...base,
      opacity: 0.70,
      color: '#213144',
    }
  }
};

//----------------------------------------------------------------------
// MISC
//----------------------------------------------------------------------

export const filterOptions = (options: Array<Option>) => (inputValue: string) =>
  options.filter((items) => items.label.toLowerCase().includes(inputValue.toLowerCase()));

export function optionsToMap(arr: Array<Option>) {
  return new Map(arr.map((item, idx) => [item.value, { ...item, idx }]));
}

export function isValidOption(option: Option | null | undefined): option is Option {
  return !isNil(option) && !isNil(option.value);
}

export const normalizeSelectData = (option: Option) => ({
  id: option.value,
  text: option.label
});

export const normalizeDropdownData = (item: Item) => ({
  value: item.id,
  label: stripHtml(item.text)
});